// src/pages/Dashboard.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaTasks, FaCheckCircle, FaFileAlt } from "react-icons/fa";
import { environmentalURL } from "../environmentalURL";
const Dashboard = () => {
  const [jobData, setJobData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [careerRes, jobRes] = await Promise.all([
          axios.get(`${environmentalURL}/api/careers/all`),
          axios.get(`${environmentalURL}/api/jobs/findall`),
        ]);

        const jobList = jobRes.data;

      const enrichedJobData = careerRes.data.map((career) => {
  const matchedJob = jobList.find((job) => job.id === career.jobId);

  return {
    ...career,
    position: matchedJob?.position || "N/A",
  };
});

        setJobData(enrichedJobData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const cardStyle = {
    flex: 1,
    backgroundColor: "white",
    padding: "1.5rem",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.5rem",
  };

  const iconWrapper = {
    fontSize: "1.5rem",
    color: "#3b82f6",
    marginBottom: "0.5rem",
  };

  const tableHeader = {
    padding: "0.75rem",
    backgroundColor: "#f1f5f9",
    fontWeight: "bold",
    color: "#111827",
    borderBottom: "2px solid #e5e7eb",
    textAlign: "left",
  };

  const tableCell = {
    padding: "0.75rem",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "14px",
    color: "#374151",
    // verticalAlign: "middle",
    whiteSpace: "nowrap", // Prevent awkward wrapping
    overflow: "hidden",
    textOverflow: "ellipsis", // Add ellipsis for long names
    maxWidth: "200px", 
  };


  const detailsButton = {
    padding: "0.4rem 0.8rem",
    border: "1px solid #3b82f6",
    backgroundColor: "white",
    color: "#3b82f6",
    borderRadius: "6px",
    fontSize: "13px",
    cursor: "pointer",
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fc", padding: "2rem" }}>
      <h2 style={{ marginBottom: "1.5rem", fontSize: "24px", color: "#111827", fontWeight: "bold" }}>Dashboard Overview</h2>

      {/* Stats Cards */}
      <div style={{ display: "flex", gap: "1.5rem", marginBottom: "2rem" }}>
        <div style={cardStyle}>
          <div style={iconWrapper}><FaTasks /></div>
          <h3 style={{ fontSize: "16px", margin: 0 }}>Total Job Applications</h3>
          <p style={{ fontSize: "22px", fontWeight: "bold" }}>{jobData.length}</p>
        </div>
        <div style={cardStyle}>
          <div style={{ ...iconWrapper, color: "#10b981" }}><FaCheckCircle /></div>
          <h3 style={{ fontSize: "16px", margin: 0 }}>Hired</h3>
          <p style={{ fontSize: "22px", fontWeight: "bold" }}>0</p>
        </div>
        <div style={cardStyle}>
          <div style={{ ...iconWrapper, color: "#f59e0b" }}><FaFileAlt /></div>
          <h3 style={{ fontSize: "16px", margin: 0 }}>Rejected</h3>
          <p style={{ fontSize: "22px", fontWeight: "bold" }}>0</p>
        </div>
      </div>

      {/* Table Section */}
      <h3 style={{ marginBottom: "1rem", fontSize: "24px", color: "#1f2937", fontWeight: "bold", marginBottom: "30px" }}>Candidate Applications</h3>
      <div style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
              <th style={tableHeader}>Full Name</th>
              <th style={tableHeader}>Email</th>
              {/* <th style={tableHeader}>Position </th> */}
              <th style={tableHeader}>Mobile</th>
              <th style={tableHeader}>Applied Date</th>
              <th style={tableHeader}>Actions</th>
              {/* <th style={tableHeader}>Status</th> */}
          </thead>
          <tbody>
            {jobData.map((job, i) => {
              const isExpanded = expandedRow === i;
              return (
                <React.Fragment key={i}>
                  <tr>
              <td style={{ ...tableCell, fontWeight: "normal" ,textAlign:"left"}}>{job.fullName || "N/A"}</td>
<td style={{ ...tableCell, fontWeight: "normal" ,textAlign:"left"}}>{job.emailId || "N/A"}</td>

                    {/* <td style={{ ...tableCell,fontWeight: "normal" ,textAlign:"left"}}>{job.position || "N/A"}</td> */}
                    <td style={{ ...tableCell,fontWeight: "normal" ,textAlign:"left"}}>{job.mobileNumber || "N/A"}</td>
                    <td style={{ ...tableCell,fontWeight: "normal" ,textAlign:"left"}}>
                      {job.createdDate ? new Date(job.createdDate).toLocaleDateString() : "N/A"}
                    </td>
                    <td style={{ ...tableCell,fontWeight: "normal" ,textAlign:"left"}}>
                      <button
                        onClick={() => setExpandedRow(isExpanded ? null : i)}
                        style={detailsButton}
                      >
                        {isExpanded ? "Hide" : "Details"}
                      </button>
                    </td>
                    {/* <td style={tableCell}>...</td> */}
                  </tr>
                  {isExpanded && (
                    <tr>
                      <td colSpan="6" style={{ ...tableCell, backgroundColor: "#f9fafb" }}>
                        <div style={{ padding: "1rem", lineHeight: "1.6" }}>
                          <p><strong>Full Name:</strong> {job.fullName}</p>
                          <p><strong>Email:</strong> {job.emailId}</p>
                          {/* <p><strong>Position:</strong> {job.position || "N/A"}</p> */}

                          <p><strong>Mobile:</strong> {job.mobileNumber}</p>
                          <p><strong>Cover Letter:</strong> {job.coverLetter || "N/A"}</p>
                          <p><strong>Resume:</strong>{" "}
                            {job.resumeFilePath ? (
                              <>
                                <a
                                  href={job.resumeFilePath}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#10b981", textDecoration: "underline" }}
                                >
                                  View Resume
                                </a>

                              </>
                            ) : (
                              "Not Uploaded"
                            )}
                          </p>


                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>


    </div>
  );
};

export default Dashboard;
